import React, { useEffect } from "react"
import { makeStyles } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';


const useStyles = makeStyles((theme) => ({
    formControl: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        minWidth: 80,
        width: "-webkit-fill-available"
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

function FormDialog(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const { op, setOp, title, func, fields, pass } = props

    useEffect(() => {
        setOpen(op)
    }, [op])


    const handleClose = () => {
        setOpen(false);
        setOp(false)
    };

    return (
        <div>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    < TextField
                        margin="dense"
                        label="Տաբելային N"
                        type="text"
                        fullWidth
                        value={fields.tabelNumber.value}
                        onChange={(e) => { fields.tabelNumber.func(e.target.value) }}
                    />
                    < TextField
                        margin="dense"
                        label="Անուն"
                        type="text"
                        fullWidth
                        value={fields.firstName.value}
                        onChange={(e) => { fields.firstName.func(e.target.value) }}
                    />
                    < TextField
                        margin="dense"
                        label="Ազգանուն"
                        type="text"
                        fullWidth
                        value={fields.lastName.value}
                        onChange={(e) => { fields.lastName.func(e.target.value) }}
                    />
                    < TextField
                        margin="dense"
                        label="Հայրանուն"
                        type="text"
                        fullWidth
                        value={fields.middleName.value}
                        onChange={(e) => { fields.middleName.func(e.target.value) }}
                    />
                    < TextField
                        margin="dense"
                        label="Պաշտոն"
                        type="text"
                        fullWidth
                        value={fields.position.value}
                        onChange={(e) => { fields.position.func(e.target.value) }}
                    />
                    <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-label">Ստորաբաժանում</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={fields.department.value}
                            onChange={(e) => fields.department.func(e.target.value)}
                        >
                            {Object.keys(fields.department.data).map(el => (
                                <MenuItem key={el} value={fields.department.data[el].department}>{fields.department.data[el].department}</MenuItem>
                            ))}


                        </Select>
                    </FormControl>
                    < TextField
                        margin="dense"
                        label="էլ․ հասցե"
                        type="text"
                        fullWidth
                        value={fields.email.value}
                        onChange={(e) => { fields.email.func(e.target.value) }}
                    />
                    {pass ?
                        < TextField
                            margin="dense"
                            label="Գաղտնաբառ"
                            type="password"
                            fullWidth
                            value={fields.password.value}
                            onChange={(e) => { fields.password.func(e.target.value) }}
                        />
                        : <></>}
                    <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-label">Իրավասություն</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={fields.role.value}
                            onChange={(e) => fields.role.func(e.target.value)}
                        >
                            {Object.keys(fields.role.data).map(el => (
                                <MenuItem key={el} value={fields.role.data[el].name}>{fields.role.data[el].name}</MenuItem>
                            ))}


                        </Select>
                    </FormControl>

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Չեղարկել
          </Button>
                    <Button onClick={func} color="primary">
                        Հաստատել
          </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default FormDialog